import { RouteLocation } from 'lib/types/maps'

// Helper function to validate coordinates
export const isValidCoordinate = (lat?: number, lng?: number): boolean => {
  return (
    lat != null &&
    lng != null &&
    !isNaN(lat) &&
    !isNaN(lng) &&
    lat !== 0 &&
    lng !== 0 &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180
  )
}

export const getValidLocations = (
  locations: RouteLocation[],
): RouteLocation[] => {
  return locations.filter((loc) =>
    isValidCoordinate(loc.latitude, loc.longitude),
  )
}
